import { useEffect } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { usePageTrack } from 'shared/helpers/Analytics';
import { useFlag } from 'shared/settings/FeatureToggles';
import { trackTripsEvent } from './data/TripsAnalytics';
import { TripsProvider } from './data/TripsProvider';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { LoadsImportZone } from '../loads/core/LoadsImportZone';
import { lazyImport } from 'shared/routing/LazyRoute';

const CreateTripPage = lazyImport(
  () => import('./TripsPages'),
  'CreateTripPage',
);
const TripsDetails = lazyImport(() => import('./TripsPages'), 'TripsDetails');
const TripsList = lazyImport(() => import('./TripsPages'), 'TripsList');

function TripsContainerLayout() {
  usePageTrack('Trips');

  useEffect(() => {
    trackTripsEvent({ name: 'CTMS: Opened React Trips Page' });
  }, []);

  return (
    <TripsProvider>
      <PermissionView name="trips" permission="can_view">
        <Outlet />
      </PermissionView>
    </TripsProvider>
  );
}

export const tripsRoutes: RouteObject[] = [
  {
    path: 'trips',
    element: <TripsContainerLayout />,
    children: [
      {
        path: 'create',
        element: <CreateTripPage />,
      },
      {
        path: 'view/:tripGUID/:page?/:action?/:loadGUID?',
        element: <TripsDetails />,
      },
      {
        path: ':action?/:actionGUID?',
        element: <TripsListRoute />,
      },
    ],
  },
];

function TripsListRoute() {
  const shouldShowDropzone = useFlag('ctms_loads_dropzone');

  return shouldShowDropzone ? (
    <LoadsImportZone>
      <TripsList />
    </LoadsImportZone>
  ) : (
    <TripsList />
  );
}
